import {API} from "../../backend"
// API is basically path

// Backend for Signin
export const psignin = partner => {
    return fetch(`${API}/partnersignin`, {
        method: "POST",
        headers: {
            "Accept" : "application/json",
            "Content-Type" : "application/json"
        },
        body: JSON.stringify(partner)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => console.log(err));
};

export const pChangePassword = (partnerPassword, partnerId, token) => {
    return fetch(`${API}/partner/password/change/${partnerId}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(partnerPassword)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => console.log(err));
};


export const pauthenticate = (data, next) => {
    if(typeof window !== "undefined") {
        localStorage.setItem("eSession", JSON.stringify(data))
        next();
    }
}

// Backend for Signout
export const psignout = next => {
    if(typeof window !== "undefined") {
        localStorage.removeItem("eSession")
        next();

        return fetch(`${API}/partnersignout`, {
          method: "GET"  
        })
        .catch(err => console.log(err))
    }
};

export const pisAuthenticated = () => {
    if(typeof window == "undefined") {
        return false
    }
    if(localStorage.getItem("eSession")) {
        return JSON.parse(localStorage.getItem("eSession"));
    } else {
        return false;
    }
};